import { TOOL_CATALOG } from '../catalog';
import type { InvocationShapeType } from '../../../types/backend';

/** The agent kinds a tool is offered to: the box label, and the kind as the product names it in a sentence. */
export const KINDS: { kind: InvocationShapeType; label: string; name: string }[] = [
  { kind: 'interactive', label: 'Chat agents', name: 'chat' },
  { kind: 'batch', label: 'Automation agents', name: 'automation' },
  { kind: 'sub_agent', label: 'Expert agents', name: 'expert' },
];

/** The product's name for an agent kind. */
export function kindName(kind: InvocationShapeType): string {
  const found = KINDS.find((k) => k.kind === kind);
  if (!found) throw new Error(`No name for the agent kind ${kind}`);
  return found.name;
}

/** A tool that changes something: its registry level is above read, or one of its modes is above the least. */
export function writes(actionId: string): boolean {
  const tool = TOOL_CATALOG.find((t) => t.actionId === actionId);
  if (!tool) return false;
  const modes = tool.accessModes;
  return tool.level !== 'read' || Boolean(modes && modes.modes.some((m) => m !== modes.least));
}
